module.exports = __webpack_public_path__ + "static/media/facebook.7c70191a.png";